import { GridCellProps } from "@progress/kendo-react-grid";

export interface BooleanToTextCellProps {
  trueTranslation: string;
  falseTranslation: string;
}

export default function BooleanToTextCell({
  trueTranslation,
  falseTranslation,
  ...props
}: BooleanToTextCellProps & GridCellProps) {
  const { dataItem, field } = props;

  const myField = field || "";
  const value = !dataItem[myField] ? "" : dataItem[myField];

  return <td>{value ? trueTranslation : falseTranslation}</td>;
}
